import { ITangNha } from "../../model/respone/category/ITangNha";
import { apiClient } from "../apiClient";
export const TANG_NHA_API = "tang-nha";
export const tangNhaApi = {
  SelectAll: () => apiClient.get(`${TANG_NHA_API}`),
  Insert: (payload: ITangNha) => apiClient.post(`${TANG_NHA_API}`, payload),
  Update: (payload: ITangNha) => apiClient.put(`${TANG_NHA_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${TANG_NHA_API}/${id}`),
};
